<mat-progress-bar *ngIf="showMatProgress" class="progress-bar" color="accent" mode="indeterminate"></mat-progress-bar>
<div fxLayout="row wrap" *ngIf="appointmentData.length">
  <form (ngSubmit)="book()" [formGroup]="appointmentFrom">
  <div fxFlex="100">
    <div class="m-b-20">
      <div fxLayout="row wrap">
        <h3>Appointment</h3>
      </div>
      <div fxLayout="row wrap" class="DD-container">
        <div fxFlex.gt-sm="45" fxFlex.gt-xs="100" fxFlex="100">
          <mat-form-field>
            <mat-label>Select Service</mat-label>
            <mat-select placeholder="Select Service" [formControl]="appointmentFrom.controls['service']" (selectionChange)="onChangeService($event)">
                <mat-option [value]="item.resource.id" *ngFor="let item of appointmentData">{{item.resource.name}}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div fxFlex.gt-sm="45" fxFlex.gt-xs="100" fxFlex="100">
          <mat-form-field>
            <mat-label>Select Date</mat-label>
            <input matInput [min]="minDate" [matDatepicker]="picker3" [value]="setDate.value"
              (dateChange)="getSlotsByDate($event.value)">
            <mat-datepicker-toggle matSuffix [for]="picker3"></mat-datepicker-toggle>
            <mat-datepicker md-min-date="minDate" #picker3></mat-datepicker>
          </mat-form-field>
        </div>
      </div>
    </div>
    <div fxLayout="row wrap" class="m-b-20" *ngIf="selectedService.slots.length">
        <div fxFlex="11.3" class="round-btn" *ngFor="let slot of selectedService.slots" (click)="onSelectSlot(slot)"
        [ngClass]="{'timeout': slot.isTimeOut, 'unavailable-slot': slot.slot_status === 'UNAVAILABLE', 'freeSlot': slot.slot_status === 'FREE'&&!slot.isTimeOut, 'selectedSlot': slot.selected}">
          <div class="time">{{slot.startTime| slice:0:5}}-{{slot.endTime | slice:0:5}}</div>
        </div>
    </div>
    <div fxLayout="row wrap" class="m-b-20" *ngIf="!selectedService.slots.length">
        <h3>No slots available for this service!!</h3>
    </div>
    <!-- <div fxLayout="row wrap" class="m-b-20" fxLayoutAlign.xs="space-around center">
      <div fxFlex.gt-sm="100" fxFlex="100">
        <mat-chip-list *ngIf="selectedService.slots.length"> 
          <mat-chip class="m-b-10" [disabled]="slot.isTimeOut || slot.slot_status === 'UNAVAILABLE'" *ngFor="let slot of selectedService.slots" (click)="onSelectSlot(slot)"
            [ngClass]="{'unavailable-slot': slot.slot_status === 'UNAVAILABLE', 'freeSlot': slot.slot_status === 'FREE', 'selectedSlot': slot.selected}">
            {{slot.startTime| slice:0:5}}-{{slot.endTime | slice:0:5}}
          </mat-chip>
        </mat-chip-list>
        <div *ngIf="!selectedService.slots.length">
          <h1>No slots available for this service!!</h1>
        </div>
      </div>
    </div> -->
    <div fxLayout="row" fxLayoutAlign="center center">
      <label class="m-r-15"><i class="fa fa-circle-thin m-r-5"></i>Free</label>
      <label class="m-r-15"><i class="fa fa-circle m-r-5 booked"></i>Booked</label>
      <label class="m-r-15"><i class="fa fa-circle m-r-5 selected"></i>Selected</label>
    </div>
    <div fxLayout="row" class="m-l-r-5">
      <button type="submit" [disabled]="isSubmitBtnDisabled" mat-raised-button color="primary" class="m-r-20">Book
        Now</button>
      <button type="button" mat-raised-button (click)="onNoClick()" class="m-r-5">Cancel</button>
    </div>
  </div>
</form>
</div>